import React, { Component } from 'react'
import { Link, Redirect } from 'react-router-dom'
import Header from '../../components/header'
import Skeleton from '../../components/skeleton'
import './styles.css'
import { NOME_EMPRESA } from '../../config'
import { connect } from 'react-redux'

import Footer from '../../components/footer'
import { apiEmployee } from '../../services/apiamrg'
import moment from 'moment'
import { confirmAlert } from 'react-confirm-alert'

class Inicio extends Component {

    state = {
        isLogado: true,
        loading: false,

        tickets: [],
        status: -1,
        statusOptions: [
            { label: "Todos", value: -1 },
            { label: "Em digitação", value: 0 },
            { label: "Aguardando aprovação", value: 1 },
            { label: "Aprovado", value: 2 },
            { label: "Cancelado", value: 3 },
        ]
    }

    componentDidMount() {
        this.getTickets();
    }

    getTickets = async () => {
        apiEmployee.get(`/tickets/ticketsCreditos/${this.props.id}`)
            .then(res => this.setState({
                tickets: res.data
            }))
    }

    cancelTicket = (id, nome) => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className='custom-ui text-center'>
                        <h1>{NOME_EMPRESA}</h1>
                        <div>
                            <span>Deseja cancelar este ticket? (de {nome})</span>
                        </div>
                        <button
                            style={{ marginRight: 5 }}
                            className="btn btn-danger w-25"
                            onClick={
                                async () => {
                                    onClose()
                                }
                            }
                        >
                            Não
                        </button>
                        <button
                            style={{ marginRight: 5 }}
                            className="btn btn-success w-25"
                            onClick={
                                async () => {
                                    const ticket = this.state.tickets.find((t) => t.chave == id)

                                    if (ticket.status != 0) {
                                        await apiEmployee.delete(`tickets/cancelar/${id}`).then(
                                            async response => {
                                                if (response.data == true) {
                                                    document.location.reload()
                                                }
                                            },
                                            async response => {
                                                this.erroApi(response)
                                            }
                                        )
                                    } else {
                                        await apiEmployee.delete(`tickets/apagar/${id}`).then(
                                            async response => {
                                                if (response.data == true) {
                                                    document.location.reload()
                                                }
                                            },
                                            async response => {
                                                this.erroApi(response)
                                            }
                                        )
                                    }
                                    onClose()
                                }
                            }

                        >
                            Sim
                        </button>
                    </div>
                )
            }
        })
    }

    erroApi = async (res) => {
        await this.setState({ isLogado: false })
        alert('Você precisa estar logado para poder acessar esta página!')
        this.setState({ redirect: true })
    }

    render() {

        return (
            <div className='page'>
                {!this.state.isLogado &&
                    <Redirect to={'/'} />
                }
                {this.state.loading &&
                    <Skeleton />
                }
                <Header />

                <Footer />
            </div>
        )
    }

}

const mapStateToProps = ({ user, servidor }) => {
    return {
        token: user.token,
        id: user.id,
        online: servidor.online
    }
}

export default connect(mapStateToProps, null)(Inicio)

/*
                                <li className="w-100 text-left itemMenu list-group-item ">
                                    <Link className="semTextDecoration" to={{pathname: `/admin/employees`}}>
                                        <FontAwesomeIcon icon={faUsersCog} size="2x" color="tomato" />
                                        <h4 className="textoMenu">Users</h4>
                                    </Link>
                                </li>
*/